<div mat-dialog-title class="position-relative px-4 py-3 mb-0 title-border">
  <h2 class="mb-0">
    Job Details
    <span class="f-12 fw-400 text-grey-light">(LYNK ID#: {{ data.lynk }})</span>
  </h2>
  <span class="material-icons position-absolute close-icon-modal" (click)="close()">close</span>
</div>
<div mat-dialog-content class="content-modal">
  <div class="mb-0 mt-3">
    <div class="row mb-3">
      <div class="col-sm-12">
        <div class="d-flex flex-wrap align-item-start justify-content-between heading-with-price">
          <div class="heading">
            <h3 class="mb-0 fw-500 black bid-pop-heading">
              {{ data.postedBy.name }}
            </h3>
            <p class="f-12 text-grey-medium m-0">
              Posted On: {{ data.postedOn }}
            </p>
            <div class="d-flex arrow-wrapper">
              <span *ngFor="let iDetail of data.details; let i = index">
                <h3 class="mb-0 fw-500 black bid-pop-heading">
                  {{ iDetail.addressId.city }}, {{ iDetail.addressId.country }}
                  <span *ngIf="i < data.details.length - 1" class="arrow-img">
                    <img src="assets/images/two-arrow-head.svg" alt="" />
                  </span>
                </h3>
              </span>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Service Type:</strong>
              {{ data.loadServiceType == 1 ? "Full" : "Partial" }}</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Total Weight:</strong>
              {{ data.totalWeight | WeightKgToLbs: data.unit }}</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Trailer Type:</strong>
              {{ data.trailerTypeId.type }}</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Type of Pick-up:</strong>
              {{
              data.pickupDropoffType == 1 ? "Single Stop" : "Multiple Stop"
              }}</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">No. of Bids:</strong>
              {{ data.noOfBids }}</span>
          </div>

          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Trailer Size:</strong>
              {{ data.trailerSizeId.size }} Feet</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Product Hazmat:</strong>
              {{ data.productHazmat == "true" ? "Yes" : "No" }}</span>
          </div>
          <div class="col-md-4 col-sm-6 d-flex mb-2">
            <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Shipment Value: </strong>{{
              data.loadValue | currency : "USD" : "symbol" : "1.2-2"
              }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 my-3">
        <hr />
      </div>
    </div>
  </div>
</div>
<div mat-dialog-content class="content-modal">
  <div class="mb-2">
    <div class="d-flex flex-wrap align-item-start justify-content-between heading-with-price flex-column">
      <div class="mb-2">
        <h3 class="mb-0 fw-500 black bid-pop-heading">Driver Information</h3>
        <br />
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-md-4 col-sm-6 d-flex mb-2">
              <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Driver Name:</strong>
                {{ this._driverName }}</span>
            </div>
            <div class="col-md-4 col-sm-6 d-flex mb-2">
              <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Trailer Type:</strong>
                {{ this._trailerType }}</span>
            </div>
            <div class="col-md-4 col-sm-6 d-flex mb-2">
              <span class="fw-500 f-14 text-grey-medium"><strong class="fw-500 d-black">Trailer Size:</strong>
                {{ this._trailerSize }} Feet</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="_showData || _showData2; else AcceptOrDecline">
    <div mat-dialog-actions class="justify-content-end pr-3">
      <div class="d-flex flex-column align-items-end text-right pr-2">
        <div class="d-flex align-items-center">
          <div class="tooltip-wrapper">
            <button class="f-18 btn green_btn fw-500 min-width-btn accept-btn" [disabled]="
                !bookNow || DriverStatus === 'OnLeave' || DriverStatus === 'Inactive'
              " type="submit" (click)="onSubmit()">
              Book Now
            </button>

            <span class="tooltip-text" *ngIf="bookNow && (DriverStatus === 'OnLeave' || DriverStatus === 'Inactive')">
              {{
              DriverStatus === "OnLeave"
              ? "You cannot assign the job as you are on leave"
              : "You cannot assign the job as your status is inactive"
              }}
            </span>
          </div>
          <button *ngIf="_showData2" class="f-18 btn red_btn fw-500 min-width-btn ml-3" type="submit"
            (click)="openOfferDecline()">
            <i class="f-16 material-icons icon-left mr-2">cancel</i> Decline
          </button>
        </div>
        <div class="red_text error-msg mt-2 text-right" *ngIf="!bookNow">
          No trailers are available for the selected requirements.
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #AcceptOrDecline>
    <div mat-dialog-actions class="justify-content-center">
      <div class="tooltip-wrapper w-100">
        <div class="tooltip-wrapper w-100 d-flex justify-content-end">
          <button
            class="f-18 btn sml_rounded_btn large_btn green_btn fw-500"
            [disabled]="
              DriverStatus === 'OnLeave' || DriverStatus === 'Inactive'
            " type="submit" (click)="onSubmit()">
            Accept
          </button>

          <span class="tooltip-text" *ngIf="DriverStatus === 'OnLeave' || DriverStatus === 'Inactive'">
            {{
            DriverStatus === "OnLeave"
            ? "You cannot assign the job as you are on leave."
            : "You cannot assign the job as your status is inactive"
            }}
          </span>

          <button class="f-18 btn sml_rounded_btn large_btn red_btn fw-500" type="submit"
            (click)="openOfferDecline()">
            Decline
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
